module.exports = __webpack_public_path__ + "img/btn-azimuthal-grid.bd02effc.svg";